import EventFormPageActionTypes from '../actions/event-form-page-action-types';

const initialState = {
  loading: false,
  event: null,
  validationResult: null,
  cancellationTokenSources: new Map()
};

export default (state = initialState, action) => {
  switch (action.type) {
    case EventFormPageActionTypes.LOAD_EVENT_FORM_PAGE_START:
      return {
        ...state,
        loading: true,
        validationResult: null
      };
    case EventFormPageActionTypes.LOAD_EVENT_FORM_PAGE_END:
      return {
        ...state,
        loading: false,
        event: action.payload ? action.payload.event : null,
        validationResult: action.payload ? action.payload.validationResult : null
      };
    default:
      return state;
  }
};
